import { useTranslation, Trans } from 'react-i18next';
import Footer from '../../components/Footer';
import PageHeader from '../../components/PageHeader';

function NewsCalendar() {
  const { t } = useTranslation();
  return (
    <div id="top">
      {/* <Preloader> */}
      {/* <Navbar /> */}
      <PageHeader
        title={t('calendarPage.title')}
        page={t('calendarPage.page')}
        pageUrl={'/news/calendar'}
      />
      {/* <!-- ==== Page Content ==== --> */}
      <div className="page">
        <div className="container">
          <div className="row">
            {/* <!-- Post Content Column --> */}
            <div className="col-lg-8 col-xl-9 card blog-card">
              <div className="card-body">
                <h3 className="card-title">{t('calendarPage.page_title')}</h3>
                {/* <!-- Post info--> */}
                <div className="post-info border-irregular2 text-muted">
                  Novembar 1, 2025
                </div>
                <hr />
                {/* <!-- Preview Image --> */}
                <img src="/img/calendar_collage.webp" className="img-fluid" alt="" />
                <hr />
                {/* <!-- Post Content --> */}
                <p className="lead">{t('calendarPage.post_lead')}</p>
                <p>
                  <Trans
                    i18nKey="calendarPage.post_content_2"
                    components={{
                      b: <b />,
                    }}
                  />
                </p>
                <p>
                  <Trans
                    i18nKey="calendarPage.post_content_3"
                    components={{
                      b: <b />,
                    }}
                  />
                </p>
                <h6>{t('calendarPage.price_info')}</h6>
                <p>
                  <Trans
                    i18nKey="calendarPage.post_content_4"
                    components={{
                      b: <b />,
                    }}
                  />
                </p>
                <p>
                  <b>{t('calendarPage.post_content_5')}</b>
                </p>
                <p>
                  {t('calendarPage.post_content_order')}:{' '}
                  <a href="mailto:pawfriendssarajevo@gmail.com">
                    pawfriendssarajevo@gmail.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default NewsCalendar;
